var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"container",attrs:{"id":"container"}},[_c('div',{attrs:{"id":"turntable"}}),_c('img',{staticClass:"btn",attrs:{"src":_vm.imageUrl},on:{"click":_vm.starlotter}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }